<block>
    <block-title>
        {{ 'oskaProfessions.label' | translate }}
    </block-title>
    <block-content>
        <listItems [list]="list" type="mainProfession" compare="oskaProfessionsComparison"></listItems>
    </block-content>
</block>

